import MicroModal from 'micromodal';

const openModal = document.querySelectorAll('.hero-modal__open-button');
const closeModal = document.querySelector('.hero-modal__close-button');
const firstButton = document.querySelector('.hero-modal__cta-button-1');

if (openModal && closeModal && firstButton) {
  openModal.forEach((button) => {
    button.addEventListener('click', () => {
      MicroModal.show('hero-modal');
      // removes the focus state so the button will be blue instead of white on modal open
      firstButton.blur();
    });
  });

  closeModal.addEventListener('click', () => {
    MicroModal.close('hero-modal');
  });
}
